// Brand assets — served locally from /public/brand for reliability (no cross-origin CDN dependency)
export const FGM = {
    logos: {
        white: "/brand/White.png",
        gray: "/brand/Gray.png",
        black: "/brand/Black.png",
    },
    video: "/brand/hero.mp4",
    ambassadorFlyer: "/brand/ambassador.jpeg",
    lookbook: [
        "/lookbook/look1.jpg",
        "/lookbook/look2.jpg",
        "/lookbook/look3.jpg",
        "/lookbook/look4.jpg",
    ],
};
